import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import i18n from './i18n/i18n'; // Initialize i18n FIRST before any components load
import MainApp from './App'; // Renamed from App to MainApp for clarity
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './styles/antd-overrides.css';
import './styles/fonts.css';
import { ConfigProvider, App } from 'antd';
import {QueryClientProvider, QueryClient } from "@tanstack/react-query";
import fi_FI from 'antd/locale/fi_FI';
import en_US from 'antd/locale/en_US';
import sv_SE from 'antd/locale/sv_SE';
import { loadGoogleTagManager } from './analytics/googleTagManager';
import { captureAttributionFromUrl } from './analytics/attribution';
import { config } from './config';

const antdLocaleMap = { fi: fi_FI, en: en_US, sv: sv_SE };

const theme = {
    token: {
        fontFamily: 'Aptos Display, sans-serif',
        colorPrimary: '#ff670e',
        borderRadius: 4,
    },
};
const queryClient = new QueryClient();

captureAttributionFromUrl(window.location);
loadGoogleTagManager(config.gtmId);

const AntdLocaleWrapper = ({ children }) => {
    const [locale, setLocale] = useState(antdLocaleMap[i18n.language] || en_US);

    useEffect(() => {
        const handleLanguageChanged = (lng) => {
            setLocale(antdLocaleMap[lng] || en_US);
        };
        i18n.on('languageChanged', handleLanguageChanged);
        return () => i18n.off('languageChanged', handleLanguageChanged);
    }, []);

    return (
        <ConfigProvider locale={locale} theme={theme}>
            {children}
        </ConfigProvider>
    );
};

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <AntdLocaleWrapper>
        <QueryClientProvider client={queryClient}>
        <App> {/* This is the new wrapper component */}
            <React.StrictMode>
                <BrowserRouter>
                    <AuthProvider>
                        <MainApp /> {/* Your original App component is now rendered here */}
                    </AuthProvider>
                </BrowserRouter>
            </React.StrictMode>
        </App>
        </QueryClientProvider>
    </AntdLocaleWrapper>
);
